<template>
  <div class="mx-auto">
    <b-card border-variant="secondary"
            text-variant="secondary"
            :title="$t('unitDetails.profileTitle')"
            align="center"
            style="max-width: 40rem;"
            class="mx-auto mb-3">
        <UnitDetailRowItem change-type="none" :data="$store.getters.getUnitNumber" :title="$t('unitDetails.description')"/>
        <UnitDetailRowItem change-type="contactName" :data="$store.getters.getUnitContactName" :title="$t('unitDetails.contactName')"
          @changeUnitItem="openChangeItemPage" :editLabel="$t('unitDetails.editName')"/>
        <UnitDetailRowItem change-type="email" :data="$store.getters.getUnitContactEmail" :title="$t('unitDetails.contactEmail')"
          @changeUnitItem="openChangeItemPage"  :editLabel="$t('unitDetails.editEmail')"/>
        <UnitDetailRowItem change-type="phoneNumber" :data="$store.getters.getUnitContactPhone" :title="$t('unitDetails.phoneNumber')"
          @changeUnitItem="openChangeItemPage" :editLabel="$t('unitDetails.editPhoneNumber')"/>
    </b-card>

    <IdentityDetails v-if="this.$store.getters.isLinkedIdentityAllowed" />

    <b-card  border-variant="secondary"
             :title="$t('unitDetails.portalAccess')"
             align="center"
             style="max-width: 40rem;"
             body-text-variant="secondary"
             class="mx-auto">
      <b-row align-content="start" border-variant="light" class="mb-2 border-bottom border-light text-left">
        <b-col cols="4" class="text-dark font-weight-bold">{{ $t("unitDetails.portalUrl")}}</b-col>
        <b-col cols="6"><a v-bind:href="$store.getters.getUnitTenantPortalUrl" class="text-primary">{{this.getPortalUrlWithoutQueryParams()}}</a></b-col>
        <b-col cols="2">
          <b-button variant="outline-primary" size="sm" @click="$router.push({ name: 'ChangeAccessToken'})"  v-b-tooltip.hover.topright :title="$t('unitDetails.chanceAccessTokenToolTip')">
            <b-icon icon="pencil-fill"></b-icon>
          </b-button>
        </b-col>
      </b-row>
      <b-button v-b-modal.modal_portal_qrCode class="mb-1"  variant="outline-primary"> {{ $t('unitDetails.portalQrCodeButton') }} </b-button>
      <PortalQrModel :url="$store.getters.getUnitTenantPortalUrl"/>
    </b-card>
  </div>

</template>

<script>

import store from "../store/store";
import UnitDetailRowItem from "@/components/UnitDetailRowItem";
import router from '@/router/index'
import PortalQrModel from "@/components/PortalQrModel";
import IdentityDetails from "../components/IdentityDetails.vue";

export default {
  name: 'unitContactDetails',
  components:{
    UnitDetailRowItem,
    PortalQrModel,
    IdentityDetails
  },
  async mounted () {
    await store.dispatch("loadUnitInformationFromApi")
  },
  methods: {
    getPortalUrlWithoutQueryParams(){
      let urlSplit = store.getters.getUnitTenantPortalUrl.split('?')
      return urlSplit[0]
    },
    openChangeItemPage(e){
      if(e === "unitSecret" || e === "guestSecret"){
        router.push({ name: 'ChangeUnitSecret', params: {changeRequested: e}})
      }else if(e==="phoneNumber"){
        router.push({ name: 'ChangeUnitPhoneDetails', params: {changeRequested: e}})
      }else{
        router.push({ name: 'ChangeUnitDetails', params: {changeRequested: e}})
      }
    }
  }
}
</script>